(ns ui.view.nev.view-selector
  (:require
   [re-frame.core :as rf]
   [ui.view.nev.sub :as sub]
   [ui.components.radix-ui.popover.view :as popover]
   [reagent.core :as r]
   [common.localization :as loc]
   [ui.util :as uu]))

(defn trigger
  [{:keys [selected-option]}]
  [:div
   {:class "flex items-center gap-2 hover:text-base-light-text-paler max-w-72 overflow-hidden"}
   [:i {:class "fal fa-eye"}]
   [:span
    {:class "font-medium text-sm m-0 text-nowrap overflow-hidden text-ellipsis"}
    (:label selected-option)]])

(defn view-option-item
  [{:keys [value label first? last? selected? select-view]}]
  [:button
   {:on-click #(select-view value)
    :class (uu/cm "relative hover:bg-complement-light py-2"
                  (when first? "rounded-t")
                  (when last? "rounded-b"))}
   [:div
    {:class "flex justify-start items-center"}
    [:div
     {:class "flex items-center w-5 shrink-0"}
     (when selected?
       [:i {:class "fas fa-circle text-xxs m-0 text-base-light-text-paler"}])]
    [:p
     {:class "text-start"}
     label]]])

(defn content
  [{:keys [options selected-option select-view ctx]}]
  [:div
   {:class "flex flex-col gap-1 min-w-56 max-w-80 max-h-56 overflow-hidden"}
   [:p
    {:class "text-sm font-semibold text-base-light-text-paler m-0 pl-8 pt-2"}
    (loc/tr :select-view)]
   [:div
    {:class "flex flex-col grow overflow-hidden overflow-y-auto px-2 pb-2"}
    (->> options
         (map-indexed
          (fn [index {:keys [value label]}]
            (let [first? (zero? index)
                  last? (= index (dec (count options)))
                  selected? (= value (:value selected-option))]
              ^{:key (str "view-" value)}
              [view-option-item
               {:ctx ctx
                :value value
                :label label
                :first? first?
                :last? last?
                :selected? selected?
                :select-view select-view}]))))]])

(defn view
  [_props]
  (let [popover-open?* (r/atom false)]
    (fn [{:keys [ctx select-view]}]
      (let [selected-view-option @(rf/subscribe [::sub/view-option ctx])
            view-options @(rf/subscribe [::sub/view-options ctx])
            select-view (fn [view-id]
                          (select-view view-id)
                          (reset! popover-open?* false))]
        [popover/view
         {:as-child? false
          :open? @popover-open?*
          :on-open-change #(reset! popover-open?* %)
          :direction :bottom-left
          :dom-id "nev-view-selector-popover"
          :content-class "p-0"}
         [trigger
          {:selected-option selected-view-option}]
         [content
          {:ctx ctx
           :options view-options
           :select-view select-view
           :selected-option selected-view-option}]]))))
